export default __webpack_public_path__ + "static/media/Deepnote.d16a5b28.png";